import React from 'react';
import { Icon, Card } from '@blueprintjs/core';
import { ContactForm } from '../../components';
import './ContactPage.scss';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-page__hero section--gradient">
        <div className="container">
          <div className="contact-page__hero-content">
            <span className="contact-page__eyebrow">Let's Connect</span>
            <h1>Get in Touch</h1>
            <p>
              Ready to learn more about Living Benefits? I'm here to answer your questions
              and help you find the right protection for your family.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section">
        <div className="container">
          <div className="contact-page__content">
            <div className="contact-page__info">
              <h2>Let's Start a Conversation</h2>
              <p className="contact-page__intro">
                Whether you have questions about Living Benefits, want to review your current
                coverage, or are ready to get a free quote, I'd love to hear from you.
              </p>

              <div className="contact-page__methods">
                <Card className="contact-page__method">
                  <Icon icon="envelope" size={24} />
                  <div>
                    <h3>Email</h3>
                    <a href="mailto:rolita@livingbenefits.com">rolita@livingbenefits.com</a>
                    <p>I typically respond within 24 hours</p>
                  </div>
                </Card>

                <Card className="contact-page__method">
                  <Icon icon="phone" size={24} />
                  <div>
                    <h3>Phone</h3>
                    <a href="tel:+15551234567">(555) 123-4567</a>
                    <p>Mon-Fri, 9am - 6pm PT</p>
                  </div>
                </Card>

                <Card className="contact-page__method">
                  <Icon icon="map-marker" size={24} />
                  <div>
                    <h3>Service Area</h3>
                    <span>Nationwide</span>
                    <p>Serving clients across the United States</p>
                  </div>
                </Card>
              </div>

              <div className="contact-page__what-to-expect">
                <h3>What to Expect</h3>
                <ul>
                  <li>
                    <Icon icon="tick" size={16} />
                    <span><strong>Free consultation</strong> — No cost, no obligation</span>
                  </li>
                  <li>
                    <Icon icon="tick" size={16} />
                    <span><strong>Personalized review</strong> — We'll discuss your specific needs</span>
                  </li>
                  <li>
                    <Icon icon="tick" size={16} />
                    <span><strong>Clear explanations</strong> — No jargon, just honest answers</span>
                  </li>
                  <li>
                    <Icon icon="tick" size={16} />
                    <span><strong>No pressure</strong> — Take all the time you need to decide</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="contact-page__form-wrapper">
              <Card className="contact-page__form-card">
                <h2>Send a Message</h2>
                <p>Fill out the form below and I'll get back to you as soon as possible.</p>
                <ContactForm />
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Quick Links */}
      <section className="section section--light">
        <div className="container">
          <div className="contact-page__faq-section">
            <h2>Common Questions</h2>
            <p className="contact-page__section-subtitle">
              Here are some quick answers to questions I hear frequently.
            </p>
            <div className="contact-page__faq-grid">
              <div className="contact-page__faq-item">
                <h3>How much does a consultation cost?</h3>
                <p>
                  Nothing! My consultations are completely free with no obligation.
                  I'm happy to answer your questions and provide information.
                </p>
              </div>
              <div className="contact-page__faq-item">
                <h3>How quickly can I get coverage?</h3>
                <p>
                  Many policies can be issued within 24-48 hours. Some may require
                  a brief health questionnaire or exam depending on coverage amount.
                </p>
              </div>
              <div className="contact-page__faq-item">
                <h3>Do you work with specific companies?</h3>
                <p>
                  I work with multiple top-rated insurance carriers to find the best
                  Living Benefits products for your specific situation and budget.
                </p>
              </div>
              <div className="contact-page__faq-item">
                <h3>Can you help if I have health issues?</h3>
                <p>
                  Yes! There are Living Benefits products available for various health
                  conditions. Let's discuss your situation and explore your options.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
